import type { ReactElement } from 'react'
import { TextFieldCustom } from './CustomTextField.styles'

const CustomTextField = (props): ReactElement => {
  return <TextFieldCustom {...props} />
}

export default CustomTextField
